export const staffLinks = [
  { title: "Bethlehem Inn Website", description: "Official Bethlehem Inn public website.", href: "https://bethleheminn.org/" },
  { title: "Bethlehem Inn YouTube", description: "Official Bethlehem Inn Bend YouTube page.", href: "https://www.youtube.com/@BethlehemInnBend" },
  { title: "Onboarding Portal", description: "Bethlehem Inn staff onboarding and training portal.", href: "https://bionboarding.netlify.app/" },
] as const;
